import { create } from 'zustand';

/**
 * Feature flag del configuratore Motornet: interruttori UI-only, indipendenti dai
 * dati del veicolo, che decidono quanto esporre di dettagli "interni". Oggi
 * riguardano il gemello tecnico delle vernici collassate, ma lo store è il punto
 * unico dove aggiungerne altri.
 */
export type ConfiguratorFeatures = {
	/** Mostra la riga del gemello vernice nello spec panel / riepilogo. */
	showTwinInSpec: boolean;
	/** Cita codice/nome del gemello nel tooltip della riga vernice. */
	showTwinInfo: boolean;
	/** Rende il gemello trovabile dalla ricerca optional (per codice/nome). */
	showTwinInSearch: boolean;
	/**
	 * Mostra la sezione "Verranno automaticamente esclusi" nel dialog di
	 * validazione API.
	 */
	showExcludedSection: boolean;
	/** Quanti optional mostrare per categoria prima di "Visualizza tutti". */
	optionsPreviewCount: number;
	/** Quante righe di equipaggiamento di serie mostrare prima di "Vedi tutto". */
	equipmentPreviewCount: number;
	/** Aggiorna uno o più flag. */
	setFeatures: (
		patch: Partial<Omit<ConfiguratorFeatures, 'setFeatures'>>
	) => void;
};

export const useConfiguratorFeatures = create<ConfiguratorFeatures>((set) => ({
	showTwinInSpec: false,
	showTwinInfo: false,
	showTwinInSearch: false,
	showExcludedSection: false,
	optionsPreviewCount: 5,
	equipmentPreviewCount: 5,
	setFeatures: (patch) => set(patch),
}));
